export default {
  FILES(state, payload) {
    state.files = payload || {}
  },
  SET_ACTIVE_FILE(state, payload) {
    state.activeFile = payload || ''
  }
}



// WEBPACK FOOTER //
// ./src/app/store/files/mutations.js